<template>
  <div id="checkout-info">
    <div v-if="hasInvalidInputs">
      <AppAlert
        :input="inputErrors"
        :className="'app-alert-error'"
        :class="'app-alert-error'"
        colorType="danger"
        :getTextFromOptions="translateErrorText"
        />
    </div>
    <div class="checkout-info-title">
      Até <span class="bold">{{simulation.numberOfInstallments}} vezes</span>
      de <span class="bold">{{simulation.pmt | moneyFilter}}</span> no boleto ou pix
    </div>
    <div
      class="checkout-info-subtitle" :class="{ mobile: isMobile() }">
      Valor total de {{ simulation.totalValue | moneyFilter }}
    </div>
    <div class="checkout-info-body" :class="{ mobile: isMobile() }">
      Para verificar seu perfil de crédito é necessária uma análise das suas informações
      inseridas. Por isso é muito importante que você forneça seus dados reais,
      como CPF e endereço próprios.
    </div>
    <div class="checkout-info-footer" :class="{ mobile: isMobile() }">
      <VerifyButton
      v-if="!isMobile()"
        @verify="creditVerify"
        @completed="onBtnVerifyFilled"
        :disabled="hasInvalidInputs"
        ref="verify-btn"
        class="verify-button"
        :width="isMobile () ? '100%' : '200px'"/>
      <div class="checkout-info-disclaimer" :class="{ mobile: isMobile() }">
        Estou de acordo com o
        <a target="_blank"
          href="https://www.parcelex.com.br/termos-de-uso">
          Termo de uso
        </a>
        e
        <a
          target="_blank"
          href="https://www.parcelex.com.br/politica-de-privacidade">
          Política de Privacidade
        </a>
        do Parcelex.
      </div>
      <VerifyButton
        v-if="isMobile()"
        @verify="creditVerify"
        @completed="onBtnVerifyFilled"
        :disabled="hasInvalidInputs"
        ref="verify-btn"
        class="verify-button"
        :width="isMobile () ? '100%' : '200px'"/>
      <div class="checkout-info-simulation" :class="{ mobile: isMobile() }">
        Esta é uma simulação com juros e CET de 3,35% ao mês. O valor total
         pode variar de acordo com a taxa de juros, que é definida a partir de
         seu perfil de crédito.
      </div>
    </div>
    <div class="return-button" :class="{ mobile: isMobile() }">
      <Button class="link button-link" :class="{ mobile: isMobile() }" :href="checkoutUrl">
        Cancelar e voltar para loja
      </Button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import VerifyButton from '@/components/common/VerifyButton.vue';
import StringMixin from '@/mixins/string';
import UtilMixin from '@/mixins/util';
import Button from '@/components/ui/AppButton.vue';
import AppAlert from '../../checkout/components/AppAlert.vue';

export default {
  name: 'checkout-info',
  data: () => ({
    translateErrorText: (inputErrors) => {
      const textOptions = {
        phone: 'O campo Telefone precisa ser um número válido',
        email: 'O campo E-mail precisa ter um domínio válido',
        cpf: 'O campo CPF precisa ter 11 números',
        shipping: 'Preencha os dados de entrega corretamente',
        genericError: 'Você deve preencher apenas dados válidos.',
      };
      if (Array.isArray(inputErrors)) {
        if (inputErrors.length === 1) {
          return textOptions[inputErrors[0]] || '';
        } if (inputErrors.length > 1) {
          return textOptions.genericError;
        }
      }
      return '';
    },
  }),
  computed: {
    ...mapGetters('checkoutRedirect', [
      'simulation',
      'isApproved',
      'setApproved',
      'setDenied',
    ]),
    ...mapState('checkoutRedirect', [
      'inputErrors',
      'checkoutUrl',
    ]),
    hasInvalidInputs() {
      return Array.isArray(this.inputErrors) && this.inputErrors.length >= 1;
    },
  },
  mixins: [StringMixin, UtilMixin],
  methods: {
    ...mapActions('checkoutRedirect', [
      'getOptions',
      'goToPage',
      'emitEvent',
    ]),
    isNumberNotNaN(val) {
      return typeof val === 'number' && val >= 0;
    },
    async creditVerify() {
      try {
        await this.getOptions();
        this.$refs['verify-btn'].complete(this.isApproved);
      } catch (error) {
        this.$emit('onError', error);
      }
    },
    onBtnVerifyFilled() {
      this.$emit('buttonCompleted');
    },
  },
  mounted() {
    this.emitEvent({
      type: 'application',
    });
  },
  components: {
    VerifyButton,
    AppAlert,
    Button,
  },
};
</script>

<style lang="scss" scoped>
.checkout-info-title {
  @extend .h3;
  @extend .gray-700;
  font-weight: normal;
  margin-bottom: 8px;
  font-size: 18px;
  line-height: 28px;
}

.checkout-info-subtitle {
  @extend .small-semibold;
  @extend .gray-400;
  margin-bottom: 16px;
  font-size: 14px;
  line-height: 20px;
  &.mobile {
    @extend .gray-500;
    font-size: 16px;
    line-height: 24px;
  }
}

.checkout-info-body {
  @extend .small-regular;
  margin-bottom: 20px;
  @extend .gray-700;
  font-size: 16px;
  line-height: 24px;
  &.mobile {
    font-size: 18px;
    line-height: 24px;
  }
}

.checkout-info-disclaimer {
  @extend .small-regular;
  margin-top: 12px;
  &.mobile {
    margin-bottom: 20px;
  }
}

.checkout-info-simulation {
  @extend .gray-500;
  margin-top: 16px;
  font-size: 14px;
  line-height: 20px;
  &.mobile {
    margin-top: 20px;
  }
}

.checkout-info-footer.mobile {
  margin-top: 0px;
}

.return-button {
  &.mobile {
    display: flex;
    justify-content: center;
  }
  .button-link {
    font-size: 12px;
    line-height: 16px;
    padding: 0px;
    margin-bottom: 20px;
    &.mobile {
      margin-bottom: 30px;
    }
  }
}
</style>
